import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import api from "../lib/api";

export const CategoriesStrip = () => {
  const [cats, setCats] = useState([]);

  useEffect(() => {
    api.get("/categories").then((r) => setCats(r.data.categories || []));
  }, []);

  return (
    <section
      className="py-20 md:py-28 bg-jow-cream"
      data-testid="home-categories"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between mb-12">
          <div>
            <span className="label-overline text-jow-gold">The Edits</span>
            <h2 className="font-display text-4xl md:text-5xl mt-2 text-jow-navy">
              Featured Categories
            </h2>
          </div>
          <Link
            to="/shop"
            data-testid="categories-view-all"
            className="hidden sm:inline-flex label-overline text-jow-pink hover:underline"
          >
            View all →
          </Link>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-6 gap-6 md:gap-10">
          {cats.slice(0, 6).map((c, i) => (
            <motion.div
              key={c.slug}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
            >
              <Link
                to={`/shop/${c.slug}`}
                data-testid={`category-${c.slug}`}
                className="group block text-center"
              >
                <div className="aspect-square overflow-hidden rounded-full border border-jow-gold/40 bg-white mb-4">
                  <img
                    src={c.image_url}
                    alt={c.name}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    loading="lazy"
                  />
                </div>
                <p className="font-display text-base md:text-lg text-jow-navy">
                  {c.name}
                </p>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
